import React, {useEffect, useState} from 'react';
import _ from "lodash";
import SelectTags from "../../tag/select-tags";
import SelectThemes from "../../theme/components/select-themes";
import ImageSidebarSection from "../image-sidebar/image-sidebar-section";
import ImageSidebarItem from "../image-sidebar/image-sidebar-item";

const SelectImageList = ({
                             selectedImageList,
                             prepareSelectedImageList,
                             setSelectedImageList,
                             filterCriteria,
                             setFilterCriteria,
                             allThemes,
                             allTags,
                         }) => {
    const [selectedImageIdList, setSelectedImageIdList] = useState(_.map(selectedImageList, 'id'));
    const [refreshImages, setRefreshImages] = useState(false);

    const handleThemeTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingFilterCriteria = {...filterCriteria};
        existingFilterCriteria[name] = value;

        if (name === 'themeList') {
            const tempThemes = {};
            _.forEach(value, themeId => {
                tempThemes[themeId] = true;
            });

            existingFilterCriteria['themes'] = tempThemes;
            existingFilterCriteria['themeList'] = value;
        }

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingFilterCriteria['tags'] = tempTags;
            existingFilterCriteria['tagList'] = value;
        }

        setFilterCriteria(existingFilterCriteria);
    }

    const handleRemoveAllImages = () => {
        setSelectedImageIdList([]);
        setSelectedImageList([]);
        prepareSelectedImageList([]);
    }

    const handleSelectAllImages = (imagesList) => {
        const existingSelectedImageList = [...selectedImageList];
        const tempSelectedImageIdList = _.map(existingSelectedImageList, 'id');
        const existingSelectedImageIdList = [...selectedImageIdList];

        _.forEach(imagesList, (imageDetail) => {
            if (tempSelectedImageIdList.indexOf(imageDetail.id) === -1) {
                existingSelectedImageList.push(imageDetail);
                tempSelectedImageIdList.push(imageDetail.id);
            }

            if (existingSelectedImageIdList.indexOf(imageDetail.id) === -1) {
                existingSelectedImageIdList.push(imageDetail.id);
            }
        });

        setSelectedImageList(existingSelectedImageList);
        prepareSelectedImageList(existingSelectedImageList);
        setSelectedImageIdList(existingSelectedImageIdList);
    }

    const handleSelectedImage = (imageDetail) => {
        const existingSelectedImageList = [...selectedImageList];
        const tempSelectedImageIdList = _.map(existingSelectedImageList, 'id');

        if (tempSelectedImageIdList.indexOf(imageDetail.id) === -1) {
            imageDetail.isAdded = true;
            existingSelectedImageList.push(imageDetail);
        }

        const existingSelectedImageIdList = [...selectedImageIdList];
        if (existingSelectedImageIdList.indexOf(imageDetail.id) === -1) {
            existingSelectedImageIdList.push(imageDetail.id);
        }

        setSelectedImageList(existingSelectedImageList);
        prepareSelectedImageList(existingSelectedImageList);
        setSelectedImageIdList(existingSelectedImageIdList);
    }

    const handleRemoveImage = (imageDetail) => {
        let existingSelectedImageList = [...selectedImageList];
        let existingSelectedImageIdList = [...selectedImageIdList];

        existingSelectedImageIdList = _.remove(existingSelectedImageIdList, function (existingImageId) {
            return existingImageId !== imageDetail?.id;
        });

        existingSelectedImageList = _.remove(existingSelectedImageList, function (existingImage) {
            return existingImage?.id !== imageDetail?.id;
        });

        setSelectedImageList(existingSelectedImageList);
        prepareSelectedImageList(existingSelectedImageList);
        setSelectedImageIdList(existingSelectedImageIdList);
    }

    return (
        <>

            <div className="flex justify-start">

                <div className='w-1/4 mr-3'>

                    {allThemes &&
                        <div
                            className="h-64 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mt-4">
                            <SelectThemes
                                existingThemes={filterCriteria?.themeList}
                                allThemes={allThemes}
                                handleSelectThemesChanges={handleThemeTagChanges}
                                showClearSelectedThemes={false}
                                showClearSelectedThemesIcon={false}/>
                        </div>
                    }

                    {allTags &&
                        <div
                            className="select-tags-table-container overflow-y-scroll border-gray-400 border bg-blue-50 rounded">
                            <SelectTags
                                existingTags={filterCriteria?.tagList}
                                allTags={allTags}
                                handleSelectTagsChanges={handleThemeTagChanges}
                                showAddTag={false}
                                showClearSelectedTags={true}
                                showClearSelectedTagsIcon={true}/>
                        </div>
                    }

                </div>

                <div className='w-1/2 mx-3'>

                    <div
                        className="select-images-table-container overflow-y-scroll border-gray-400 border bg-gray-400 rounded mt-4">
                        <ImageSidebarSection
                            setSelectedImage={handleSelectedImage}
                            tags={filterCriteria?.tagList}
                            themes={filterCriteria?.themeList}
                            ignoreInitialSelection={true}
                            selectedImageIdsList={selectedImageIdList}
                            refreshImages={refreshImages}
                            setRefreshImages={setRefreshImages}
                            showSelectAll={true}
                            handleSelectAllImages={handleSelectAllImages}
                            handleRemoveAllImages={handleRemoveAllImages}/>
                    </div>

                </div>

                <div className='w-1/3 ml-6'>
                    <div className="mb-4 text-xl">
                        Selected Images
                    </div>

                    <div
                        className={`selected-images-table-container overflow-y-scroll border border-gray-400 bg-gray-400 p-4`}>
                        <div className="flex flex-wrap justify-center mt-2">
                            {selectedImageList?.map((image, index) => (
                                <React.Fragment key={index}>
                                    {image?.thumbnail &&
                                        <div>
                                            <ImageSidebarItem
                                                imageDetail={image}
                                                setSelectedImage={undefined}
                                                removeImage={handleRemoveImage}
                                                showRemove={true}
                                                selectedImageIdsList={selectedImageIdList}/>
                                        </div>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default SelectImageList
